// StyleObserver looks for changes on the styles attribute of target element
// and then calls the callback function
class StyleObserver {
    constructor(target, callback) {

        if (target !== null) {
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutationRecord) {
                    callback();
                });
            });
            observer.observe(target, { attributes: true, attributeFilter: ['style'] });
        }
    }
}
